import React from 'react';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { Question } from '../../../../types/course';

interface TrueFalseEditorProps {
    question: Question;
    onChange: (updatedQuestion: Question) => void;
}

const TrueFalseEditor: React.FC<TrueFalseEditorProps> = ({ question, onChange }) => {
    const correctAnswer = question.correctAnswer === true;

    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>Correct Answer:</Typography>
            <FormControl component="fieldset">
                <RadioGroup
                    row
                    value={correctAnswer.toString()}
                    onChange={(e) => onChange({ ...question, correctAnswer: e.target.value === 'true' })}
                >
                    <FormControlLabel value="true" control={<Radio color="success" />} label="True" />
                    <FormControlLabel value="false" control={<Radio color="error" />} label="False" />
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default TrueFalseEditor;
